import { Reveal, SectionHeading } from "./Reveal";
import { FEATURED } from "@/data/content";

const SLUGS = [
  "corporate-refinancing-capex",
  "hospitality-project-finance",
  "private-credit-opportunities",
];

const FeaturedRequirements = () => (
  <section
    id="featured"
    data-testid="featured-requirements-section"
    className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16 lg:py-32"
  >
    <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
      <SectionHeading
        number="07"
        label="Mandate Snapshot"
        title="Featured capital requirements"
      />
      <Reveal delay={0.1}>
        <p className="max-w-sm text-xs font-light italic leading-relaxed text-slate-500">
          Illustrative and representative of the types of requirements we
          evaluate. Details are anonymised and do not represent completed
          transactions or outcomes.
        </p>
      </Reveal>
    </div>

    <div className="mt-16 grid grid-cols-1 gap-px border border-white/10 bg-[#0D1220]/10 md:grid-cols-3">
      {FEATURED.map((deal, i) => (
        <Reveal key={deal.title} delay={i * 0.08} className="h-full">
          <article
            data-testid={`featured-deal-${SLUGS[i]}`}
            className="group relative flex h-full flex-col bg-[#0B0F17] p-8 transition-[background-color,transform,box-shadow] duration-500 hover:-translate-y-1 hover:bg-[#111827] hover:shadow-[0_28px_56px_-28px_rgba(16,23,37,0.25)]"
          >
            <div
              className="pointer-events-none absolute inset-3 border border-white/10"
              aria-hidden="true"
            />
            <span className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-slate-600">
              Illustrative requirement
            </span>
            <p className="mt-6 font-display text-4xl font-light text-[#F26122] sm:text-5xl">
              {deal.amount}
            </p>
            <h3 className="mt-4 font-display text-xl font-normal text-slate-100">
              {deal.title}
            </h3>
            <div className="mt-auto pt-8">
              <div className="hairline-gold mb-5 opacity-40" aria-hidden="true" />
              <ul className="flex flex-wrap gap-x-4 gap-y-1">
                {deal.meta.map((m) => (
                  <li
                    key={m}
                    className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-slate-500"
                  >
                    {m}
                  </li>
                ))}
              </ul>
            </div>
          </article>
        </Reveal>
      ))}
    </div>
  </section>
);

export default FeaturedRequirements;
